import produce from 'immer';
import { create } from 'zustand';

import { OfficeDto, PaginatorInfo } from '@graphql/hooks-and-types';
// GetOfficesListingQuery['getOfficesListing']
type PropertyState = {
  state: {
    properties: OfficeDto[];
    paginator: Partial<PaginatorInfo>;
  };
  setProperties: (properties: OfficeDto[], paginatorInfo: Partial<PaginatorInfo>) => void;
  getProperties: () => OfficeDto[];
  getPropertyPaginator: () => Partial<PaginatorInfo>;
};

export const useProperties = create<PropertyState>()((set: any, get: any) => ({
  state: {
    properties: [],
    paginator: {
      perPage: 10,
      hasMorePages: false,
      count: 0,
      currentPage: 1,
      lastPage: 1,
      total: 0,
    },
  },
  setProperties: (properties, paginatorInfo) =>
    set(
      produce((draft: PropertyState) => {
        draft.state.paginator = paginatorInfo;
        if (paginatorInfo.currentPage === 1) {
          draft.state.properties = properties;
          return;
        }
        draft.state.properties.push(...properties);
      }),
    ),
  getProperties: () => get().state.properties,
  getPropertyPaginator: () => get().state.paginator,
}));
